import { render, staticRenderFns } from "./BasicDataGrid.vue?vue&type=template&id=8e027ba2&scoped=true&"
import script from "./BasicDataGrid.vue?vue&type=script&lang=js&"
export * from "./BasicDataGrid.vue?vue&type=script&lang=js&"
import style0 from "./BasicDataGrid.vue?vue&type=style&index=0&id=8e027ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e027ba2",
  null
  
)

export default component.exports